import type { PlayerVerticalSliceView, ResourceDisplay } from '@aztec-realms/shared-types';

/** Presentation only: the server remains the capability and spend authority. */
export function plannedBuildingCapabilities(
  config: Record<string, unknown>,
  level: number,
  branch?: string,
): string[] {
  const branches = config.branch_capabilities as Record<string, unknown> | undefined;
  const grants = [config.world_capabilities, branch ? branches?.[branch] : undefined];
  return [
    ...new Set(
      grants.flatMap((group) =>
        Array.isArray(group)
          ? group.flatMap((item: unknown) => {
              if (!item || typeof item !== 'object') return [];
              const grant = item as Record<string, unknown>;
              const minimum = grant.min_level ?? 1;
              return typeof grant.code === 'string' &&
                typeof minimum === 'number' &&
                Number.isInteger(minimum) &&
                minimum >= 1 &&
                minimum <= level
                ? [grant.code.replaceAll('_', ' ')]
                : [];
            })
          : [],
      ),
    ),
  ];
}

export function missingBuildingResources(
  cost: readonly ResourceDisplay[],
  balances: readonly ResourceDisplay[],
) {
  return cost.flatMap((resource) => {
    const have = balances.find((item) => item.code === resource.code)?.amount ?? 0;
    return have < resource.amount ? [{ ...resource, have, missing: resource.amount - have }] : [];
  });
}

export function settlementPlayAction(snapshot: PlayerVerticalSliceView) {
  const decode = snapshot.decode;
  if (decode.profileCode !== 'tutorial' && decode.status !== 'solved') {
    return {
      label: 'Continue your Decode',
      href: '/decode',
      description:
        decode.rewardMode === 'civic_only' || decode.rewardMode === 'weave_only'
          ? 'This challenge does not award building materials.'
          : 'Your current glyph shows its available rewards.',
    };
  }
  return {
    label: 'Find a resource challenge',
    href: '/explore',
    description: 'Choose a challenge in Explore. Daily Codex needs no location.',
  };
}
